/**
 * Cart Offers — View Offers panel for the cart drawer.
 *
 * Loaded via theme.liquid as a deferred script, so it runs once on page load
 * and survives every subsequent AJAX section re-render (innerHTML never
 * re-executes script tags, but this file is already active).
 *
 * All interaction is handled with document-level event delegation so the
 * #viewOffersBtn / #cartOffersOverlay elements do not need to be in the DOM
 * at the time this script runs.
 */

(function () {
  'use strict';

  /* ── DOM helpers (called fresh each time so stale refs never bite) ── */
  function overlay()  { return document.getElementById('cartOffersOverlay'); }
  function openBtn()  { return document.getElementById('viewOffersBtn'); }
  function closeBtn() { return document.getElementById('cartOffersClose'); }
  function backdrop() { return document.getElementById('cartOffersBackdrop'); }

  /* ── State ─────────────────────────────────────────────────────── */
  function isOpen() {
    var el = overlay();
    return el && el.classList.contains('is-open');
  }

  /* ── Open / close ───────────────────────────────────────────────── */
  function openOverlay() {
    var el = overlay();
    var ob = openBtn();
    var cb = closeBtn();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (ob) ob.setAttribute('aria-expanded', 'true');
    if (cb) setTimeout(function () { cb.focus(); }, 50);
  }

  function closeOverlay() {
    var el = overlay();
    var ob = openBtn();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (ob) ob.setAttribute('aria-expanded', 'false');
  }

  /* ── Apply coupon ───────────────────────────────────────────────── */
  function applyCoupon(code) {
    if (!code) return;

    var input = (
      document.querySelector('#cart input[name="discount"]') ||
      document.querySelector('form[action*="/cart"] input[name="discount"]')
    );
    var applyBtn = (
      document.querySelector('#cart [data-discount-btn]') ||
      document.querySelector('form[action*="/cart"] [data-discount-btn]')
    );

    if (input) {
      input.value = code;
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    closeOverlay();

    /* Wait for the close animation to finish before clicking Apply */
    setTimeout(function () {
      if (applyBtn) {
        applyBtn.click();
      } else if (input) {
        input.dispatchEvent(
          new KeyboardEvent('keydown', { key: 'Enter', bubbles: true })
        );
      }
    }, 380);
  }

  /* ── Document-level click delegation ───────────────────────────── */
  document.addEventListener('click', function (e) {
    /* Open panel */
    if (e.target.closest('#viewOffersBtn')) {
      openOverlay();
      return;
    }

    /* Close button */
    if (e.target.closest('#cartOffersClose')) {
      closeOverlay();
      return;
    }

    /* Backdrop */
    if (e.target.id === 'cartOffersBackdrop') {
      closeOverlay();
      return;
    }

    /* Apply coupon card */
    var couponBtn = e.target.closest('[data-coupon-code]');
    if (couponBtn) {
      applyCoupon(couponBtn.getAttribute('data-coupon-code'));
    }
  }, false);

  /* ── Keyboard ───────────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeOverlay();
  });

}());
